export default {"src":"/stays/_next/static/media/bedrooms.48737673.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};